import useClientAccountProfileQuery from '../queries/useClientAccountProfileQuery';

export default function useCheckBlackUser() {
  const { data: profile, isLoading } = useClientAccountProfileQuery({
    keepPreviousData: true,
  });

  return {
    isBlackUser: !!profile?.isBlocked,
    isLoading,
  };
}
